import { Component, Input, output } from '@angular/core';

/** The icon a tab draws. Kept as an identifier so the component owns the drawing, not its caller. */
export type MtBottomNavIcon = 'wishes' | 'wasi' | 'documents' | 'settings';

export interface MtBottomNavItem {
  readonly id: string;
  readonly label: string;
  readonly icon: MtBottomNavIcon;
}

/**
 * The root-level navigation bar. Mute like every design-system component: it receives its labels,
 * owns its icons, and reports which tab was pressed — it decides nothing about what a tab means.
 */
@Component({
  selector: 'app-bottom-nav',
  standalone: true,
  templateUrl: './mt-bottom-nav.component.html',
  styleUrl: './mt-bottom-nav.component.scss',
})
export class MtBottomNavComponent {
  @Input() items: readonly MtBottomNavItem[] = [];
  @Input() active = '';
  @Input() label = '';
  /** The round button set apart at the end of the bar. Empty label leaves it out. */
  @Input() moreLabel = '';
  @Input() moreActive = false;

  readonly selected = output<string>();
  readonly moreSelected = output();

  protected isActive(id: string): boolean {
    return id === this.active;
  }
}
